const {COUNTRY_CODE_ES, COUNTRY_CODE_PT} = require('../constants/countryCodes');

const showMemories = (originCountry, isin) => {
    if (originCountry.toUpperCase() === COUNTRY_CODE_ES && isin.substring(0, 2).toUpperCase() !== COUNTRY_CODE_ES) return true;
    else return originCountry.toUpperCase() === COUNTRY_CODE_PT;
};

module.exports = {
    showMemories
};
